<template>
  <nav
    class="navbar navbar-expand-lg navbar-primary fixed-top d-none d-lg-block bg-primary"
    id="nav"
  >
    <div class="row">
      <!--
      <div class="bg-warning container mb-3 text-center" style="height: 25px;">
        <p>
          <strong
            >{{ promoText }} {{ days }} días, {{ hours }} horas, {{ minutes }} minutos,
            {{ seconds }} segundos</strong
          >
        </p>
      </div>
      -->
      <div class="container">
        <div class="collapse navbar-collapse navbars" id="navbar1">
          <div class="navbar-header">
            <img
              :alt="configData.general.brandName"
              src="@/assets/logo.png"
              width="112px"
              @click="resetSearch()"
            />
          </div>
          <ul v-if="configData.general.isEcommercePage" class="navbar-nav ml-auto">
            <form class="navbar-form" role="search" id="navBarSearchForm">
              <div class="input-group">
                <div class="input-group-prepend">
                  <button
                    class="btn  btn-al-celeste search-buttons dropdown-toggle d-none d-lg-inline"
                    type="button"
                    data-toggle="dropdown"
                  >
                    {{ search_subcategory }}<span class="caret"></span>
                  </button>

                  <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                    <a
                      class="dropdown-item"
                      @click="setSearch_subcategory(0, 'Todas las Categorías', 0)"
                      >Todas las Categorías</a
                    >
                    <template v-for="category in categories">
                      <div class="submenu-item">
                        <template
                          v-if="
                            !category.sub_categories.find(
                              (subcate) => subcate.product_type_desc_es === '#',
                            )
                          "
                        >
                          <a
                            class="dropdown-item dropdown-toggle dropright"
                            data-toggle="dropdown"
                            id="navbarDropdownSubMenuLink"
                            role="button"
                            aria-haspopup="true"
                            aria-expanded="false"
                            @click="setSearch_category(category)"
                          >
                            <span>{{ category.product_type_desc_es }}</span>
                          </a>
                          <div class="dropdown-menu" aria-labelledby="navbarDropdownSubMenuLink">
                            <template v-for="subcategory in category.sub_categories">
                              <a
                                class="dropdown-item"
                                @click="
                                  setSearch_subcategory(
                                    subcategory.id_category,
                                    subcategory.product_type_desc_es,
                                    subcategory.category_reference,
                                  )
                                "
                                >{{ subcategory.product_type_desc_es }}</a
                              >
                            </template>
                          </div>
                        </template>
                        <template v-else>
                          <a
                            class="dropdown-item"
                            id="navbarDropdownSubMenuLink"
                            role="button"
                            @click="
                              setSearch_subcategory(
                                category.sub_categories.find(
                                  (subcate) => subcate.product_type_desc_es === '#',
                                ).id_category,
                                category.product_type_desc_es,
                              )
                            "
                          >
                            <span>{{ category.product_type_desc_es }}</span>
                          </a>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>

                <input
                  type="text"
                  class="form-control search-control"
                  v-model="searchData"
                  placeholder="Busca aquí el producto de tu interés"
                  maxlength="50"
                />

                <div class="input-group-append">
                  <template v-if="searchData == '' || searchData.length <= 2">
                    <button type="submit" disabled class="btn btn-al-celeste search-buttons">
                      <i class="fa fa-search"></i>
                    </button>
                  </template>
                  <template v-else>
                    <router-link
                      tag="button"
                      type="submit"
                      :key="'search' + searchData"
                      :to="{
                        path:
                          '/productos/0/1/' +
                          id_search_category +
                          '/' +
                          id_search_subcategory +
                          '/0/0/' +
                          searchData +
                          '',
                      }"
                      class="btn btn-al-celeste search-buttons"
                    >
                      <i class="fa fa-search"></i>
                    </router-link>
                  </template>
                </div>
              </div>
            </form>
            <template v-if="logged">
              <router-link
                :to="'/seguimiento'"
                class="btn btn-al-celeste"
                style="margin-left: 10px;border-radius: 0;"
                ><i class="fa fa-truck"></i> Seguimiento</router-link
              >
            </template>
            <template v-else>
              <button
                data-toggle="modal"
                data-target="#myModal2"
                class="btn btn-al-celeste"
                style="margin-left: 10px;border-radius: 0;"
              >
                <i class="fa fa-truck"></i> Seguimiento
              </button>
            </template>
          </ul>
          <ul class="navbar-nav ml-auto" v-if="configData.general.isLoggingAvailable">
            <li class="nav-item dropdown" v-if="logged">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdownMenuLink"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >{{ '¡Hola ' + user.name_client.split(' ')[0] + '!' }}</a
              >
              <div class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
                <router-link to="/perfil" class="dropdown-item">Mi Cuenta</router-link>
                <router-link
                  v-if="configData.general.isEcommercePage"
                  to="/pedidos"
                  class="dropdown-item"
                  >Mis Pedidos</router-link
                >
                <router-link
                  v-if="configData.general.isEcommercePage"
                  to="/seguimiento"
                  class="dropdown-item"
                  >Seguimiento</router-link
                >
                <router-link
                  v-if="configData.general.isEcommercePage"
                  to="/carrito"
                  class="dropdown-item"
                  >Mi Carrito</router-link
                >
                <router-link to="/" class="dropdown-item" @click.native="loc_logout"
                  >Cerrar Sesión</router-link
                >
              </div>
            </li>
            <li class="nav-item" v-if="!logged">
              <a class="nav-link" data-toggle="modal" data-target="#myModal2"
                ><i class="fa fa-user"></i> Iniciar Sesión</a
              >
            </li>
            <li v-if="configData.general.isEcommercePage" class="nav-item">
              <a class="nav-link cart" data-toggle="modal" data-target="#exampleModal">
                <i class="fa fa-shopping-cart mr-1"></i>
                <span class="badge badge-danger" id="lblCartCount">
                  {{ this.cartProducts.length }}
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="container" style="padding-top: 10px;">
        <div class="navbar-collapse collapse navbars" id="navbar2">
          <ul class="navbar-nav mr-auto">
            <template v-for="section in section_list">
              <li class="nav-item">
                <router-link :to="'/' + section.url_es" class="nav-link">{{
                  section.name_sec_es
                }}</router-link>
              </li>
            </template>
          </ul>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'DesktopNavbar',
  props: [
    'configData',
    'section_list',
    'categories',
    'search_subcategory',
    'user',
    'scrollPosition',
    'logged',
    'cartProducts',
    'id_search_category',
    'id_search_subcategory',
    'promoText',
  ],
  data() {
    return {
      searchData: '',
      targetDate: new Date(),
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      interval: null,
    };
  },
  mounted() {
    this.targetDate.setDate(this.targetDate.getDate() + 4);
    this.updateCountdown();
    this.interval = setInterval(this.updateCountdown, 1000);
  },
  methods: {
    resetSearch() {
      this.setSearch_subcategory(0, 'Todas las Categorías', 0);
      this.searchData = '';
      this.$router.push('/');
    },
    setSearch_subcategory(subcategory_id, subcategory_description, idcategoria) {
      this.$parent.setSearch_subcategory(subcategory_id, subcategory_description, idcategoria);
    },
    setSearch_category(category) {
      this.$parent.setSearch_category(category);
    },
    loc_logout() {
      this.$parent.loc_logout();
    },
    updateCountdown() {
      const now = new Date();
      const timeLeft = this.targetDate - now;
      this.days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      this.hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      this.minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
      this.seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);
      if (timeLeft <= 0) {
        clearInterval(this.interval);
        this.days = this.hours = this.minutes = this.seconds = 0;
      }
    },
    beforeDestroy() {
      clearInterval(this.interval);
    },
  },
};
</script>
